import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbDateParserFormatter, NgbDatepickerModule, NgbDropdownModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import moment from 'moment';

@Component({
  selector: 'app-expense-submit-form',
  standalone: true,
  imports: [LoaderComponent, CommonModule, FormsModule, NgbDropdownModule, NgSelectModule, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './expense-submit-form.component.html',
  styleUrl: './expense-submit-form.component.scss'
})
export class ExpenseSubmitFormComponent {
  isDisabled: boolean = false;

  @Input() TravelType: string = '';
  @Input() Ids: string = '';
  @Input() ESS_ExpenseRequestMainId: number = 0;
  @Input() FromDateObj: any = null;
  @Input() ToDateObj: any = null;
  
  user = [] as any;

  Data = {
    SelectType: 'FS',
    ESS_ExpenseRequestMainId: null as any,
    EmpMasterId: 0,
    TravelType: null as any,
    ReportName: null,
    FromDate: null as any,
    FromDateObj: null,
    ToDate: null as any,
    ToDateObj: null,
    ReportDesc: null,
    ESS_ExpenseRequestDetailsIds: null as any,
  }

  constructor(
    private activeModal: NgbActiveModal,
    private expense: ExpenseService,
    protected common: CommonService,
    private session: SessionService,
    private toast: ToastService,
    private utility: UtilityService,
    private modalService: NgbModal,
    private dateFormat: CustomDateParserFormatter,
    private tooltip: TooltipService,
  ) {
    this.user = this.session.GetUserDetails();
  }

  ngOnInit(): void {
    this.Data.TravelType = this.TravelType;
    if (this.common.ToLowerCase(this.TravelType) == 'outstation') {
      this.Data.ESS_ExpenseRequestMainId = this.ESS_ExpenseRequestMainId;
    }else{
      this.Data.FromDateObj = this.FromDateObj;
      this.Data.ToDateObj = this.ToDateObj;
    }
    this.Data.ESS_ExpenseRequestDetailsIds = this.Ids;
    this.Data.EmpMasterId = this.user.UserId;
  }

  Verification(form: any) {
    if (form.valid) {
      if ((moment(this.dateFormat.format(this.Data.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Data.FromDateObj), 'DD MMM YYYY')))) {
        this.ESS_ExpenseRequestInsert();
      } else {
        this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ESS_ExpenseRequestInsert() {
    const modalRef = this.modalService.open(ConfirmationComponent);
    modalRef.componentInstance.Message = 'Do you want to submit?';
    modalRef.result.then(result => {
      if (result) {
        this.isDisabled = true;
        this.Data.FromDate = this.dateFormat.format(this.Data.FromDateObj);
        this.Data.ToDate = this.dateFormat.format(this.Data.ToDateObj);
        this.expense.ESS_ExpenseRequestInsert(this.Data).subscribe({
          next: (response) => {
            if (response.Error_Code == "486") {
              const modalRef = this.modalService.open(AlertSuccessComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => {
                if (result) {
                  this.activeModal.close(true);
                }
              });
            } else {
              const modalRef = this.modalService.open(AlertWarningComponent, {
                size: 'md',
                backdrop: 'static',
                centered: true,
                windowClass: 'confirmation-modal'
              });
              modalRef.componentInstance.Message = response.Error_Message;
              modalRef.result.then((result: any) => { });
            }
            this.isDisabled = false;
          },
          complete: () => { },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      }
    });
  }

  close() {
    this.activeModal.close();
  }
}
